import { CustomAddressFormValues } from '../DeliveryAddress.types'

export const EMPTY_CUSTOM_ADDRESS_VALUES: CustomAddressFormValues = {
  street1: '',
  street2: '',
  suburb: '',
  state: '',
  postcode: '',
}
